import { createPortal } from 'react-dom';

function Modal({ children, open }) {
  return (
    open &&
    createPortal(
      <section className='fixed bg-p-bk/50 w-screen h-screen top-0 left-0 right-0 bottom-0 z-9999999999'>
        <div className=' bg-black/5 w-full h-full'>{children}</div>
      </section>,
      document.getElementById('modal-root')
    )
  );
}

export default Modal;
